import { useEffect, useState } from "react";
import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
import { API_URL } from "../helpers/api_helper";
import { Modal, Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { CreatePaymentIntent, SavePaymentData } from "../helpers/Payments";
import Toast from "./toast";

// Styled CardElement options — this is what was missing
const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      fontSize: "16px",
      color: "#1a1a1a",
      fontFamily: '"Inter", sans-serif',
      "::placeholder": { color: "#a0a0a0" },
    },
    invalid: { color: "#e53e3e" },
  },
};

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 440,
  bgcolor: "background.paper",
  borderRadius: 3,
  boxShadow: 24,
  p: 4,
};

export default function CheckoutForm({
  open,
  handleClose,
  handlePaymentSuccess,
  chatId,
}) {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;
    setLoading(true);
    setError(null);

    try {
      // const res = await fetch(`${API_URL}api/payments/create-payment-intent`, {
      //   method: "POST",
      //   headers: { "Content-Type": "application/json" },
      //   body: JSON.stringify({ chatId }),
      // });
      const res = await CreatePaymentIntent({ chatId: chatId });
      if (res.statusCode === 200 && res.isSuccess === true) {
        const { clientSecret } = res.data;

        const responsee = await stripe.confirmCardPayment(clientSecret, {
          payment_method: {
            card: elements.getElement(CardElement),
          },
        });
        const { error, paymentIntent } = responsee;
        console.log(responsee);
        if (error) {
          setError(error.message);
        } else if (paymentIntent.status === "succeeded") {
          await SavePaymentData({
            chatId: chatId,
            payment_id: paymentIntent.id,
          });
          Toast.success("Payment completed successfully.");
          handlePaymentSuccess();
        }
      } else {
        Toast.error(res.message);
        setLoading(false);
      }
    } catch (err) {
      console.log("Err", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(false);
    setError(null);
  }, [open]);

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={modalStyle}>
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            mb: 3,
          }}
        >
          <div>
            <Typography variant="h6" fontWeight={500}>
              Appointment payment
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Secure payment via Stripe
            </Typography>
          </div>
          <IconButton size="small" onClick={handleClose}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>

        <form onSubmit={handleSubmit}>
          {/* Card field label */}
          <Typography
            variant="caption"
            fontWeight={500}
            color="text.secondary"
            display="block"
            mb={0.75}
          >
            Card information
          </Typography>

          {/* ✅ CardElement must be in a styled wrapper — without this it renders as a tiny unstyled iframe */}
          <Box
            sx={{
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 2,
              px: 1.75,
              py: 1.5,
              mb: 2.5,
              "&:focus-within": {
                borderColor: "primary.main",
                boxShadow: "0 0 0 2px rgba(25,118,210,0.15)",
              },
            }}
          >
            <CardElement options={CARD_ELEMENT_OPTIONS} />
          </Box>

          {error && (
            <Typography variant="body2" color="error" mb={2}>
              {error}
            </Typography>
          )}

          <button
            type="submit"
            disabled={!stripe || loading}
            style={{
              width: "100%",
              padding: "12px",
              background: loading ? "#ccc" : "#1976d2",
              color: "white",
              border: "none",
              borderRadius: 8,
              fontSize: 15,
              fontWeight: 500,
              cursor: loading ? "not-allowed" : "pointer",
            }}
          >
            {loading ? "Processing..." : "Pay Now"}
          </button>
        </form>
      </Box>
    </Modal>
  );
}
